import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGold, errMsg, inp, lbl } from "@/components/attendance/ui";

const MODES = [["permanent", "Permanent (no expiry)"], ["until", "Until a date"], ["add_days", "Add days"], ["revoke", "Revoke free access"]];

export default function CompDialog({ org, product, onClose, onDone }) {
  const [mode, setMode] = useState("permanent");
  const [until, setUntil] = useState("");
  const [days, setDays] = useState(30);
  const [busy, setBusy] = useState(false);
  const name = product === "projection" ? "HOH Hymn Projection" : "HOH Attendance";

  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/attendance/orgs/${org.id}/comp?product=${product}`, { mode, until: mode === "until" ? until : null, days: Number(days) || 0 });
      toast.success(mode === "revoke" ? "Free access revoked" : "Free access saved");
      onDone();
    } catch (e) { toast.error(errMsg(e, "Could not save")); setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" data-testid="comp-dialog">
      <div className="bg-[#111] border border-white/10 rounded-xl w-full max-w-md p-6 space-y-4">
        <div className="flex justify-between items-start">
          <div><h3 className="font-serif-display text-2xl text-white">Complimentary access</h3><p className="text-xs text-neutral-400">{name} · {org.name}</p></div>
          <button onClick={onClose} className="text-neutral-400 hover:text-white" data-testid="comp-close"><X size={18} /></button>
        </div>
        <div className="space-y-2">
          {MODES.map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 text-sm text-neutral-200 cursor-pointer">
              <input type="radio" name="comp-mode" checked={mode === k} onChange={() => setMode(k)} className="accent-[#D4AF37]" data-testid={`comp-mode-${k}`} /> {l}
            </label>
          ))}
        </div>
        {mode === "until" && <div><label className={lbl}>Free until</label><input type="date" className={inp} value={until} onChange={(e) => setUntil(e.target.value)} data-testid="comp-until" /></div>}
        {mode === "add_days" && <div><label className={lbl}>Days to add</label><input type="number" min="1" max="3650" className={inp} value={days} onChange={(e) => setDays(e.target.value)} data-testid="comp-days" /></div>}
        <p className="text-[11px] text-neutral-500">Free access is separate from paid subscriptions and customer trials — no card or payment is involved.</p>
        <button onClick={save} disabled={busy || (mode === "until" && !until)} className={`${btnGold} w-full`} data-testid="comp-save">{busy && <Loader2 size={14} className="animate-spin" />} Save</button>
      </div>
    </div>
  );
}
